import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { IMG } from "../../config/site";

// Scroll-linked "settle": the bottle turns upright, rises and comes to rest as the section reaches centre, with a light sweep across the glass.
export const BottleStage = ({ onOpen }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "center center"] });
  const rotate = useTransform(scrollYProgress, [0, 1], [-7, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.28, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["6%", "0%"]);
  const sheen = useTransform(scrollYProgress, [0.35, 1], ["-140%", "170%"]);
  const cap = useTransform(scrollYProgress, [0.85, 1], [0, 1]);

  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={onOpen} data-testid="bottle-image-btn" aria-label="View the TOYAM bottle larger"
        className="group relative block h-[560px] w-full overflow-hidden sm:h-[640px] lg:h-full lg:min-h-[640px]">
        <motion.img src={IMG.bottle} alt="The TOYAM Alkaline Water 750 ml glass bottle with black cap and minimal gold-emblem label (design concept)" loading="lazy"
          style={reduce ? undefined : { rotate, scale, y }} className="h-full w-full origin-[50%_85%] object-cover object-center" />
        {!reduce && (
          <motion.span aria-hidden="true" style={{ x: sheen }}
            className="pointer-events-none absolute inset-y-0 left-0 w-1/2 skew-x-[-14deg] bg-gradient-to-r from-transparent via-white/40 to-transparent mix-blend-overlay" />
        )}
        <motion.span style={reduce ? undefined : { opacity: cap }}
          className="absolute left-5 top-5 text-[10px] font-bold uppercase tracking-[0.28em] text-[#8C6A3C]">TOYAM · Alkaline Water · 750 ml</motion.span>
        <span className="absolute bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap border border-[#26231F]/20 bg-[#F8F3E9]/70 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.24em] text-[#26231F] opacity-0 backdrop-blur transition-opacity duration-500 group-hover:opacity-100 group-focus-visible:opacity-100">Inspect the bottle</span>
      </button>
    </div>
  );
};
